'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _tabSwitcher = require('./tab-switcher');

var _tabSwitcher2 = _interopRequireDefault(_tabSwitcher);

var _tab = require('./tab');

var _tab2 = _interopRequireDefault(_tab);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TabbedArea = _react2['default'].createClass({
    displayName: 'TabbedArea',


    propTypes: {
        tabData: _react2['default'].PropTypes.array.isRequired,
        shouldUseTabSwitcher: _react2['default'].PropTypes.bool,
        areaClassNames: _react2['default'].PropTypes.string,
        rowClassNames: _react2['default'].PropTypes.string,
        paneAreaClassNames: _react2['default'].PropTypes.string,
        rememberActiveTab: _react2['default'].PropTypes.bool,
        tabTypes: _react2['default'].PropTypes.string,
        headerText: _react2['default'].PropTypes.string,
        bottomImage: _react2['default'].PropTypes.string,
        bottomImageWidth: _react2['default'].PropTypes.number,
        bottomImageHeight: _react2['default'].PropTypes.number
    },

    getInitialState: function getInitialState() {
        var key = 0;
        if (this.props.rememberActiveTab) {
            key = this.getSavedActiveTab();
        }

        return {
            activeTab: key,
            paneAreaClassNames: this.props.paneAreaClassNames,
            tabRowClassNames: this.props.tabRowClassNames,
            areaClassNames: this.props.areaClassNames
        };
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'areaClassNames': 'tabbed-area',
            'tabRowClassNames': 'm-tabbed-area--row row',
            'paneAreaClassNames': 'm-tabs--pane-area l-padding-v-60',
            'rememberActiveTab': false
        };
    },

    componentDidMount: function componentDidMount() {
        $(document).bind('tabClick', this.handleClickEvent);
        //FIXME: tabClick is a custom event, we should have a constant for it
    },

    componentWillUnmount: function componentWillUnmount() {
        $(document).unbind('tabClick', this.handleClickEvent);
    },

    handleClickEvent: function handleClickEvent(e) {
        if (e.key != this.state.activeTab) {
            this.onTabClick(e.key, true);
        }
    },

    onTabClick: function onTabClick(key, noEvent) {
        this.setState({ activeTab: key });
        if (noEvent !== true) {
            $(document).trigger({ 'type': 'tabClick', 'key': key });
        }

        if (this.props.rememberActiveTab) {
            this.saveActiveTab(key);
        }
    },

    onNextClick: function onNextClick() {
        var key = this.state.activeTab == this.props.tabData.length - 1 ? 0 : this.state.activeTab + 1;
        this.setState({ activeTab: key });
        if (this.props.rememberActiveTab) {
            this.saveActiveTab(key);
        }
    },

    onPrevClick: function onPrevClick() {
        var key = this.state.activeTab == 0 ? this.props.tabData.length - 1 : this.state.activeTab - 1;
        this.setState({ activeTab: key });
        if (this.props.rememberActiveTab) {
            this.saveActiveTab(key);
        }
    },

    saveActiveTab: function saveActiveTab(key) {
        if (_hfReactHelper2['default'].hasLocalStorage()) {
            localStorage.setItem('activeTab', key);
        } else if (typeof Cookie != 'undefined') {
            Cookie.set('activeTab', key, undefined, "/");
        }
    },

    getSavedActiveTab: function getSavedActiveTab() {
        var key;
        if (_hfReactHelper2['default'].hasLocalStorage()) {
            key = localStorage.getItem('activeTab');
        } else if (typeof Cookie != 'undefined') {
            key = Cookie.get('activeTab');
        }
        return key || 0;
    },

    render: function render() {

        var tabs = this.props.tabData.map(function (tab, i) {
            return _jsx(_tab2['default'], {
                clickableItemData: tab.clickableItemData,
                index: i,
                tabClassNames: tab.tabClassNames,
                onTabClick: this.onTabClick,
                isActive: this.state.activeTab == i
            }, i);
        }.bind(this));

        var panes = this.props.tabData.map(function (tab, i) {

            var classNames = {
                'is-active': this.state.activeTab == i
            };
            if (this.props.tabTypes == 'tabs') {
                classNames = _hfReactHelper2['default'].extend({ 'm-tabs--pane': true, 'row': true }, classNames);
            } else if (this.props.tabTypes == 'tiles') {
                classNames = _hfReactHelper2['default'].extend({ 'm-tabs_tiles--pane': true }, classNames);
                this.state.paneAreaClassNames = 'm-tabs_tiles--pane-area l-padding-t-40';
            }

            return _jsx('div', {
                className: (0, _classnames2['default'])(classNames)
            }, 'pane' + i, tab.contents, tab.bottomImage ? _jsx('img', {
                className: 'm-tabs_tiles--bottom-image',
                width: tab.bottomImageWidth,
                height: tab.bottomImageHeight,
                src: tab.bottomImage
            }) : null);
        }.bind(this));

        var tab_switcher = this.props.shouldUseTabSwitcher ? _jsx(_tabSwitcher2['default'], {
            onNextClick: this.onNextClick,
            onPrevClick: this.onPrevClick
        }) : '';

        {
            this.state.tabRowClassNames = this.props.tabTypes == 'tiles' ? 'columns small-12 small-centered text-center' : this.state.tabRowClassNames;
        }
        {
            this.state.areaClassNames = this.props.tabTypes == 'tiles' ? 'tabbed-area text-center l-padding-t-80' : this.state.areaClassNames;
        }

        return _jsx('div', {
            className: this.state.areaClassNames
        }, void 0, _jsx('h2', {
            className: 'm-tabs_tiles--tile-header'
        }, void 0, this.props.headerText), _jsx('div', {
            className: this.state.tabRowClassNames
        }, void 0, _jsx('div', {
            className: 'm-tabs--wrapper'
        }, void 0, tabs)), _jsx('div', {
            className: this.state.paneAreaClassNames,
            'data-equalizer': true
        }, void 0, panes, tab_switcher));
    }
});

module.exports = TabbedArea;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/tabbed-area/index.jsx
 ** module id = 797
 ** module chunks = 0
 **/